import { Pipe, PipeTransform } from '@angular/core';
import { Documento } from '../models/data.model';

@Pipe({
    name: 'docSearch',
    pure: false
})
export class docSearchPipe implements PipeTransform {
    transform(items: Documento[], filter: any): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.descrizioneDocumento.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    }
}